import { CommonModule, registerLocaleData } from "@angular/common";
import localeFr from "@angular/common/locales/fr";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { Quotation } from "@shared/models/quotation";
import { AccordionModule } from "primeng/accordion";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";

registerLocaleData(localeFr, "fr");
@Component({
  selector: "app-quotation-card",
  standalone: true,
  imports: [CardModule, CommonModule, AccordionModule, TranslateModule, ButtonModule],
  templateUrl: "./quotation-card.component.html",
})
export class QuotationCardComponent {
  @Input() quotationMember!: Quotation;

  constructor() {}
}
